svg.green{padding-top:3px;padding-left:3px}svg.green path{fill:#1db55a}
/*# sourceMappingURL=sama-logo.component.css.map */
